/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import cn from 'classnames';
import Select, { components, Props as ReactSelectProps } from 'react-select';
import { DropdownArrowIcon, CloseRoundIcon } from '../../assets/svg';
import { IDropdownOption } from '../../types';
import './styles.scss';

export const getDropdownComponents = (className?: string, isClearable?: boolean) => {
  const DropdownIndicator = (props: any): JSX.Element => (
    <components.DropdownIndicator {...props}>
      <DropdownArrowIcon />
    </components.DropdownIndicator>
  );

  const ClearIndicator = (props: any): JSX.Element => (
    <components.ClearIndicator {...props}>
      <CloseRoundIcon />
    </components.ClearIndicator>
  );

  const IndicatorSeparator = isClearable ? components.IndicatorSeparator : null;

  return {
    className: cn('hbh-select', className),
    classNamePrefix: 'rs',
    components: { ClearIndicator, DropdownIndicator, IndicatorSeparator },
  };
};

export interface IDropdown extends Omit<ReactSelectProps, 'onChange'> {
  className?: string;
  containerClassName?: string;
  error?: string | JSX.Element;
  options?: IDropdownOption[];
  isDisabled?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  placeholder?: string;
  label?: string | JSX.Element;
  onChange?: (value: IDropdownOption) => void;
}

const Dropdown = forwardRef<any, IDropdown>(
  ({ className, containerClassName, error, label, isClearable, onChange, ...rest }, ref) => {
    return (
      <div className={containerClassName}>
        {label}
        <Select
          onChange={(value) => onChange?.(value as IDropdownOption)}
          ref={ref}
          {...getDropdownComponents(className, isClearable)}
          {...rest}
        />
        {error}
      </div>
    );
  }
);

Dropdown.displayName = 'Dropdown';

export default Dropdown;
